import { render, staticRenderFns } from "./SelectItemIcon.vue?vue&type=template&id=fcc3b806"
import script from "./SelectItemIcon.vue?vue&type=script&lang=js"
export * from "./SelectItemIcon.vue?vue&type=script&lang=js"
import style0 from "./SelectItemIcon.vue?vue&type=style&index=0&id=fcc3b806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports